import React, { useState, useEffect } from "react";
import apiClient from "../api/apiClient";
import { useNavigate } from "react-router-dom";

const Login = ({ setLoggedIn }) => {
    const [credentials, setCredentials] = useState({
        username: "",
        password: "",
        database: "",
    });
    const [databases, setDatabases] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDatabases = async () => {
            try {
                const response = await apiClient.get("/databases");
                setDatabases(response.data);
            } catch (err) {
                setError("Error al cargar las bases de datos configuradas.");
            }
        };
        fetchDatabases();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials({ ...credentials, [name]: value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            // Obtener IP pública del cliente para registro en log
            let clientIp = "";
            try {
                const ipRes = await fetch("https://api.ipify.org?format=json");
                const ipData = await ipRes.json();
                clientIp = ipData.ip || "";
            } catch (_) { /* silenciar si falla */ }

            const response = await apiClient.post("/login", { ...credentials, clientIp });
            if (response.data.token) {
                const expiration = new Date();

                expiration.setMinutes(expiration.getMinutes() + 25);
                localStorage.setItem("sapToken", response.data.token);
                localStorage.setItem("sapUser", JSON.stringify({
                    UserName: credentials.username,
                    Password: credentials.password,
                    CompanyDB: credentials.database,
                    WhsCode: response.data.almacen,
                    FullName: response.data.usuario,
                    ExpiresAt: expiration.toISOString()
                }));
                setLoggedIn(true);
                navigate("/dashboard");
            } else {
                setError("Credenciales inválidas.");
            }
        } catch (err) {
            setError("Error en el inicio de sesión. Intente nuevamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid pt-5">
            <div className="row justify-content-center">
                <div className="col-12 col-sm-10 col-md-6 col-lg-4">
                    <h2 className="text-center mb-4">Inicio de Sesión</h2>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <form onSubmit={handleLogin}>
                        {/* Selección de Base de Datos */}
                        <div className="form-group">
                            <label htmlFor="database">Base de Datos</label>
                            <select
                                className="form-control form-control-sm"
                                id="database"
                                name="database"
                                value={credentials.database}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            >
                                <option value="">Seleccione una base de datos</option>
                                {databases.map((db, index) => (
                                    <option key={index} value={db.CompanyDB}>
                                        {db.CompanyName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* Campo Usuario */}
                        <div className="form-group mt-3">
                            <label htmlFor="username">Usuario</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="username"
                                name="username"
                                value={credentials.username}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            />
                        </div>
                        {/* Campo Contraseña */}
                        <div className="form-group mt-3">
                            <label htmlFor="password">Contraseña</label>
                            <input
                                type="password"
                                className="form-control form-control-sm"
                                id="password"
                                name="password"
                                value={credentials.password}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            />
                        </div>
                        {/* Botón de Iniciar Sesión */}
                        <button type="submit" className="btn btn-primary w-100 mt-4" disabled={loading}>
                            {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
